const P = process.env.PUBLIC_URL || "";

/** 中文网站名字标（与圆形 logo 搭配） */
export const CHINESE_WORDMARK = {
  white: `${P}/chinese-webname-white.png`,
  pink: `${P}/chinese-webname-pink.png`,
  black: `${P}/chinese-webname-black.png`,
} as const;

/** 深色顶栏（如首页 hero）：选 white 或 pink */
export type WordmarkOnDark = "white" | "pink";
/** 白底顶栏（陈列、空间等）：选 black 或 pink */
export type WordmarkOnLight = "black" | "pink";

/** 改这里即可试色，无需动组件 */
export const CHINESE_WORDMARK_DARK: WordmarkOnDark = "white";
export const CHINESE_WORDMARK_LIGHT: WordmarkOnLight = "black";

export function chineseWordmarkSrc(mode: "dark" | "light"): string {
  if (mode === "dark") {
    return CHINESE_WORDMARK[CHINESE_WORDMARK_DARK];
  }
  return CHINESE_WORDMARK[CHINESE_WORDMARK_LIGHT];
}
